import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletNav = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M25.2,10.1H7.8c-.6,0-1.2.2-1.8.4.3-.7.8-1.3,1.3-1.5l13.9-4.7c.3-.1.4,0,.5,0,.2.1.4.6.4,1.3v1.7h2.1v-1.7c0-1.3-.5-2.4-1.4-3-.7-.5-1.6-.6-2.4-.3L6.6,7c-1.7.7-3,2.9-3,5.1v2.2h0v11.1c0,2.3,1.9,4.2,4.2,4.2h17.4c2.3,0,4.2-1.9,4.2-4.2v-11.1c0-2.3-1.9-4.2-4.2-4.2ZM27.3,25.4c0,1.2-1,2.1-2.1,2.1H7.8c-1.2,0-2.1-1-2.1-2.1v-11.1c0-1.2,1-2.1,2.1-2.1h17.4c1.2,0,2.1,1,2.1,2.1v11.1Z" }), /* @__PURE__ */ _jsx("path", { d: "M23.2,18c-1,0-1.8.8-1.8,1.8s.8,1.8,1.8,1.8,1.8-.8,1.8-1.8-.8-1.8-1.8-1.8Z" })]
});
export default SvgWalletNav;
